/** 進程網 Play 式 to-go 跳轉（Babel 6 可編譯；本檔勿 import @/，單測用 node 直跑）。 */

export function resolveTogoJump (step) {
  if (!step) return null
  if (step.stepId === 'customer_activate') {
    return { kind: 'route', path: '/device-list-index' }
  }
  if (step.stepId === 'demand_placed' || step.stepId === 'hq_confirm' || step.stepId === 'factory_ready') {
    return { kind: 'stay', highlight: step.stepId }
  }
  if (step.routePath) {
    return { kind: 'route', path: step.routePath, query: step.query || {} }
  }
  return { kind: 'stay', highlight: step.stepId }
}

export function toGoCount (steps) {
  if (!steps || !steps.length) return 0
  var n = 0
  var i
  for (i = 0; i < steps.length; i++) {
    if (!steps[i].done) n++
  }
  return n
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/socWorkOrderTogo.js